import { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Timeline from './components/Timeline';
import Certificates from './components/Certificates';
import Terminal from './components/Terminal';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Particles from './components/Particles';
import Cursor from './components/Cursor';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black flex items-center justify-center">
        <div className="flex flex-col items-center">
          <Star className="text-purple-500 animate-pulse w-16 h-16" />
          <div className="mt-4 text-purple-400 font-orbitron text-xl">Initializing</div>
          <div className="w-48 h-1 bg-gray-800 mt-4 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-purple-600 to-blue-500 animate-loadingBar"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-black text-gray-100 font-sora overflow-hidden">
      <Cursor />
      <Particles />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Timeline />
        <Certificates />
        <Terminal />
        <Contact />
      </main>
      <Footer />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;